import script from "./HeroTagChip.vue?vue&type=script&setup=true&lang=js"
export * from "./HeroTagChip.vue?vue&type=script&setup=true&lang=js"

import "./HeroTagChip.vue?vue&type=style&index=0&id=2bc743cb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bc743cb"]])

export default __exports__